import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { I18nProvider } from "@/context/I18nContext";
import { AppModeProvider } from "@/context/AppModeContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AuthCallback from "@/components/AuthCallback";
import AppShell from "@/components/AppShell";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import ReceiptScannerPage from "@/pages/ReceiptScannerPage";
import Receipts from "@/pages/Receipts";
import Subscriptions from "@/pages/Subscriptions";
import Settings from "@/pages/Settings";
import Admin from "@/pages/Admin";
import Legal from "@/pages/Legal";
import DeleteAccount from "@/pages/DeleteAccount";

function AppRouter() {
  const location = useLocation();
  // Handle Emergent OAuth callback BEFORE any route/auth check (race-condition safe)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      {/* Public legal pages — clean URLs (no login required) */}
      <Route path="/privacy" element={<Legal doc="privacy" />} />
      <Route path="/terms" element={<Legal doc="terms" />} />
      <Route path="/ai-notice" element={<Legal doc="ai-notice" />} />
      {/* Public account deletion page (Google Play Data Safety) */}
      <Route path="/delete-account" element={<DeleteAccount />} />
      {/* Backward-compatible legacy paths */}
      <Route path="/legal/:doc" element={<Legal />} />
      <Route element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/scan" element={<ReceiptScannerPage />} />
        <Route path="/receipts" element={<Receipts />} />
        <Route path="/subscriptions" element={<Subscriptions />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App dark">
      <BrowserRouter>
        <I18nProvider>
          <AppModeProvider>
            <AuthProvider>
              <AppRouter />
              <Toaster position="top-right" theme="dark" richColors />
            </AuthProvider>
          </AppModeProvider>
        </I18nProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
